import { Route, Routes } from "react-router-dom";
import { useEffect } from "react";

import ErrorFallback from "./components/ErrorFallback";
import ErrorMissing from './components/ErrorMissing';
import Layout from "./components/Layout";
import PersistLogin from "./features/auth/PersistLogin";

import HelpAllTopics from "./features/help/HelpAllTopics";
import HelpAthleteInscription from "./features/help/accesRapide/HelpAthleteInscription";
import HelpEssentielsCompte from "./features/help/compte/HelpEssentielsCompte";
import HelpIndex from "./features/help/HelpIndex";
import HelpTopicAboutIndex from "./features/help/about/HelpTopicAboutIndex";
import HelpTopicAuthenticateEmail from "./features/help/compte/HelpTopicAuthenticateEmail";
import HelpTopicAvatar from "./features/help/compte/HelpTopicAvatar";
import HelpTopicConfigureCompte from "./features/help/accesRapide/HelpTopicConfigureCompte";
import HelpTopicCompteIndex from "./features/help/compte/HelpTopicCompteIndex";
import HelpTopicConfiance from "./features/help/securite/HelpTopicConfiance";
import HelpTopicContactAssistance from "./features/help/about/HelpTopicContactAssistance";
import HelpTopicCreateAccount from "./features/help/compte/HelpTopicCreateAccount";
import HelpTopicCreateEvent from "./features/help/about/HelpTopicCreateEvent";
import HelpTopicDeleteAccount from "./features/help/compte/HelpTopicDeleteAccount";
import HelpTopicFirstStep from "./features/help/about/HelpTopicFirstStep";
import HelpTopicFonctionnement from "./features/help/about/HelpTopicFonctionnement";
import HelpTopicGestionOrg from "./features/help/compte/HelpTopicGestionOrg";
import HelpTopicHowOrganizeEvent from "./features/help/about/HelpTopicHowOrganizeEvent";
import HelpTopicInfoCompte from "./features/help/compte/HelpTopicInfoCompte";
import HelpTopicInfoSecurity from "./features/help/compte/HelpTopicInfoSecurity";
import HelpTopicInquietude from "./features/help/securite/HelpTopicInquietude";
import HelpTopicInscriptionIndex from "./features/help/inscription/HelpTopicInscriptionIndex";
import HelpTopicMail from "./features/help/compte/HelpTopicMail";
import HelpTopicNotification from "./features/help/compte/HelpTopicNotification";
import HelpTopicPhone from "./features/help/compte/HelpTopicPhone";
import HelpTopicProtectionInfos from "./features/help/compte/HelpTopicProtectionInfos";
import HelpTopicPwd from "./features/help/compte/HelpTopicPwd";
import HelpTopicQuoiComment from "./features/help/about/HelpTopicQuoiComment";
import HelpTopicQuestionSecurite from "./features/help/securite/HelpTopicQuestionSecurite";
import HelpTopicRecentConnexions from "./features/help/compte/HelpTopicRecentConnexions";
import HelpTopicRemarque from "./features/help/about/HelpTopicRemarque";
import HelpTopicSecurePwd from "./features/help/compte/HelpTopicSecurePwd";
import HelpTopicSecurisation from "./features/help/compte/HelpTopicSecurisation";
import HelpTopicSecuriteIndex from "./features/help/securite/HelpTopicSecuriteIndex";
import HelpTopicSignalAnnonce from "./features/help/securite/HelpTopicSignalAnnonce";
import HelpTopicSignalContenUIllegal from "./features/help/securite/HelpTopicSignalContenUIllegal";
import HelpTopicSignalProbleme from "./features/help/securite/HelpTopicSignalProbleme";
import HelpTopicVerifAnnonces from "./features/help/securite/HelpTopicVerifAnnonces";
import HelpTopicRechercheConseils from "./features/help/rechercher/HelpTopicRechercheConseils";
import HelpTopicRechercheEvent from "./features/help/rechercher/HelpTopicRechercheEvent";
import HelpTopicUtilisationFiltres from "./features/help/rechercher/HelpTopicUtilisationFiltres";
import HelpTopicRechercheConditionAnnulation from "./features/help/rechercher/HelpTopicRechercheConditionAnnulation";
import HelpTopicVerifPlace from "./features/help/rechercher/HelpTopicVerifPlace";
import HelpTopicUseFavoris from "./features/help/rechercher/HelpTopicUseFavoris";
import SearchResults from "./features/help/SearchResults";
import HelpTopicApercutProfil from "./features/help/compte/HelpTopicApercutProfil";
import HelpTopicSinscrireCompetitionIndex from "./features/help/rechercher/HelpTopicSinscrireCompetitionIndex";
import HelpTopicSinscrireCompetition from "./features/help/rechercher/HelpTopicSinscrireCompetition";
import HelpTopicCodePromo from "./features/help/rechercher/HelpTopicCodePromo";
import HelpTopicConditionInscription from "./features/help/rechercher/HelpTopicConditionInscription";
import HelpTopicContactOrganisateur from "./features/help/rechercher/HelpTopicContactOrganisateur";
import HelpTopicRechercherIndex from "./features/help/rechercher/HelpTopicRechercherIndex";
import HelpTopicModification from "./features/help/inscription/HelpTopicModification";
import HelpTopicModificationInscription from "./features/help/inscription/HelpTopicModificationInscription";
import HelpTopicChangerAthlete from "./features/help/inscription/HelpTopicChangerAthlete";
import HelpTopicModifDateOver from "./features/help/inscription/HelpTopicModifDateOver";
import HelpTopicMyInscriptions from "./features/help/inscription/HelpTopicMyInscriptions";
import HelpTopicAnnulations from "./features/help/inscription/HelpTopicAnnulations";
import HelpTopicAnnutionInscription from "./features/help/inscription/HelpTopicAnnutionInscription";
import HelpTopicConditionAnnulation from "./features/help/inscription/HelpTopicConditionAnnulation";
import HelpTopicPaiementIndex from "./features/help/paiement/HelpTopicPaiementIndex";
import HelpTopicPayInscription from "./features/help/paiement/HelpTopicPayInscription";
import HelpTopicPayOutsideWodzone from "./features/help/paiement/HelpTopicPayOutsideWodzone";
import HelpTopicModePaiement from "./features/help/paiement/HelpTopicModePaiement";
import HelpTopicModifModePaiement from "./features/help/paiement/HelpTopicModifModePaiement";
import HelpTopicEchecPaiement from "./features/help/paiement/HelpTopicEchecPaiement";
import HelpTopicPayOnWodzone from "./features/help/paiement/HelpTopicPayOnWodzone";
import HelpTopicRemboursement from "./features/help/paiement/HelpTopicRemboursement";
import HelpTopicMontantRemboursement from "./features/help/paiement/HelpTopicMontantRemboursement";
import HelpTopicDelaisRemboursement from "./features/help/paiement/HelpTopicDelaisRemboursement";
import HelpTopicCommentRembourser from "./features/help/paiement/HelpTopicCommentRembourser";
import HelpTopicTarification from "./features/help/paiement/HelpTopicTarification";
import HelpTopicFraisService from "./features/help/paiement/HelpTopicFraisService";
import HelpTopicFonctionnementTarif from "./features/help/paiement/HelpTopicFonctionnementTarif";
import HelpTopicFactures from "./features/help/paiement/HelpTopicFactures";
import HelpTopicTrouverPaiement from "./features/help/paiement/HelpTopicTrouverPaiement";
import HelpTopicTrouverRecu from "./features/help/paiement/HelpTopicTrouverRecu";
import HelpTopicOptimizeAnnonce from "./features/help/accesRapide/HelpTopicOptimizeAnnonce";
import HelpTopicReceivePayment from "./features/help/accesRapide/HelpTopicReceivePayment";
import HelpTopicGestionCompetIndex from "./features/help/gestionCompet/HelpTopicGestionCompetIndex";
import HelpTopicDetailAnnonce from "./features/help/gestionCompet/HelpTopicDetailAnnonce";
import HelpTopicGeneral from "./features/help/gestionCompet/HelpTopicGeneral";
import HelpTopicDashboard from "./features/help/gestionCompet/HelpTopicDashboard";
import HelpTopicCreerAnnonce from "./features/help/gestionCompet/HelpTopicCreerAnnonce";
import HelpTopicCreerCategorie from "./features/help/gestionCompet/HelpTopicCreerCategorie";
import HelpTopicGestionParticipants from "./features/help/gestionCompet/HelpTopicGestionParticipants";
import HelpTopicCreerWOD from "./features/help/gestionCompet/HelpTopicCreerWOD";
import HelpTopicCreerAjouterScore from "./features/help/gestionCompet/HelpTopicCreerAjouterScore";
import HelpTopicCreerPlanning from "./features/help/gestionCompet/HelpTopicCreerPlanning";
import HelpTopicJuridiques from "./features/help/about/HelpTopicJuridiques";
import HelpTopicConditionsService from "./features/help/about/HelpTopicConditionsService";
import HelpTopicVersementIndex from "./features/help/versements/HelpTopicVersementIndex";
import HelpTopicFonctionnementVersements from "./features/help/versements/HelpTopicFonctionnementVersements";
import HelpTopicQuandRecevoirPaiement from "./features/help/versements/HelpTopicQuandRecevoirPaiement";
import HowWodzoneWorks from "./features/help/HowWodzoneWorks";
import HelpTopicPolitiqueConfidentialite from "./features/help/about/HelpTopicPolitiqueConfidentialite";
import HelpTopicQueues from "./features/help/inscription/HelpTopicQueues";
import HelpTopicProtectionData from "./features/help/about/HelpTopicProtectionData";

function App() {
  const documentHeight = () => {
  const doc = document.documentElement
    doc.style.setProperty('--doc-height', `${window.innerHeight}px`)
  }
  useEffect(() => {
    window.addEventListener('resize', documentHeight);
    documentHeight();
    return () => window.removeEventListener('resize', documentHeight);
  }, []);

  return (
    // <AppDataProvider >
    <>
      <Routes>
        <Route element={<PersistLogin />}>
          <Route path='/' element={<Layout />}>
              {/* Centre d'aide et tutos */}
              <Route index element={<HelpIndex />} />
              <Route path='/500' element={<ErrorFallback noFooter={true}/>} />
              <Route path="/search" element={<SearchResults />} />
              <Route path="/how-wodzone-works" element={<HowWodzoneWorks />} />

              <Route path='topics'>
                <Route index element={<HelpAllTopics />} />

                <Route path='acces-rapide'>
                  <Route path='compte' element={<HelpTopicConfigureCompte />} />
                  <Route path='inscription' element={<HelpAthleteInscription />} />
                  <Route path='optimize-annonce' element={<HelpTopicOptimizeAnnonce />} />
                  <Route path='receive-payment' element={<HelpTopicReceivePayment />} />
                </Route>

                <Route path='rechercher'>
                  <Route index element={<HelpTopicRechercherIndex />} />
                  <Route path='recherche-conseils' element={<HelpTopicRechercheConseils />} />
                  <Route path='26' element={<HelpTopicRechercheEvent />} />
                  <Route path='27' element={<HelpTopicUtilisationFiltres />} />
                  <Route path='28' element={<HelpTopicRechercheConditionAnnulation />} />
                  <Route path='29' element={<HelpTopicVerifPlace />} />
                  <Route path='30' element={<HelpTopicUseFavoris />} />
                  <Route path='sincrire-competition-index' element={<HelpTopicSinscrireCompetitionIndex />} />
                  <Route path='31' element={<HelpTopicSinscrireCompetition />} />
                  <Route path='32' element={<HelpTopicCodePromo />} />
                  <Route path='33' element={<HelpTopicConditionInscription />} />
                  <Route path='34' element={<HelpTopicContactOrganisateur />} />
                </Route>

                <Route path='inscription'>
                  <Route index element={<HelpTopicInscriptionIndex />} />
                  <Route path='64' element={<HelpTopicQueues />} />
                  <Route path='modification' element={<HelpTopicModification />} />
                  <Route path='35' element={<HelpTopicModificationInscription />} />
                  <Route path='36' element={<HelpTopicChangerAthlete />} />
                  <Route path='37' element={<HelpTopicModifDateOver />} />
                  <Route path='38' element={<HelpTopicMyInscriptions />} />
                  <Route path='annulations' element={<HelpTopicAnnulations />} />
                  <Route path='39' element={<HelpTopicAnnutionInscription />} />
                  <Route path='40' element={<HelpTopicConditionAnnulation />} />
                </Route>

                <Route path='paiement'>
                  <Route index element={<HelpTopicPaiementIndex />} />
                  <Route path='payer-inscription' element={<HelpTopicPayInscription />} />
                  <Route path='41' element={<HelpTopicPayOutsideWodzone />} />
                  <Route path='42' element={<HelpTopicModePaiement />} />
                  <Route path='43' element={<HelpTopicModifModePaiement />} />
                  <Route path='44' element={<HelpTopicEchecPaiement />} />
                  <Route path='45' element={<HelpTopicPayOnWodzone />} />
                  <Route path='remboursements' element={<HelpTopicRemboursement />} />
                  <Route path='46' element={<HelpTopicMontantRemboursement />} />
                  <Route path='47' element={<HelpTopicDelaisRemboursement />} />
                  <Route path='48' element={<HelpTopicCommentRembourser />} />
                  <Route path='tarification' element={<HelpTopicTarification />} />
                  <Route path='49' element={<HelpTopicFraisService />} />
                  <Route path='50' element={<HelpTopicFonctionnementTarif />} />
                  <Route path='factures' element={<HelpTopicFactures />} />
                  <Route path='51' element={<HelpTopicTrouverPaiement />} />
                  <Route path='52' element={<HelpTopicTrouverRecu />} />
                </Route>

                <Route path='compte'>
                  <Route index element={<HelpTopicCompteIndex />} />
                  <Route path='gestion-compte' element={<HelpTopicInfoCompte />}/>
                  <Route path='7' element={<HelpTopicAvatar />}/>
                  <Route path='8' element={<HelpTopicPwd />}/>
                  <Route path='10' element={<HelpTopicMail />}/>
                  <Route path='11' element={<HelpTopicPhone />}/>
                  <Route path='15' element={<HelpTopicGestionOrg />}/>
                  <Route path='13' element={<HelpTopicNotification />}/>
                  <Route path='securite' element={<HelpTopicInfoSecurity />}/>
                  <Route path='16' element={<HelpTopicAuthenticateEmail />}/>
                  <Route path='17' element={<HelpTopicSecurisation />}/>
                  <Route path='18' element={<HelpTopicSecurePwd />}/>
                  <Route path='19' element={<HelpTopicRecentConnexions />}/>
                  <Route path='20' element={<HelpTopicProtectionInfos />}/>
                  <Route path='1' element={<HelpTopicCreateAccount />}/>
                  <Route path='12' element={<HelpTopicDeleteAccount />}/>
                  <Route path='9' element={<HelpEssentielsCompte />}/>
                  <Route path='14' element={<HelpTopicApercutProfil />}/>
                </Route>
                
                <Route path='securite'>
                  <Route index element={<HelpTopicSecuriteIndex />} />
                  <Route path='question-securite' element={<HelpTopicQuestionSecurite />}/>
                  <Route path='21' element={<HelpTopicConfiance />}/>
                  <Route path='22' element={<HelpTopicInquietude />}/>
                  <Route path='23' element={<HelpTopicVerifAnnonces />}/>
                  <Route path='signal-probleme' element={<HelpTopicSignalProbleme />}/>
                  <Route path='24' element={<HelpTopicSignalAnnonce />}/>
                  <Route path='25' element={<HelpTopicSignalContenUIllegal />}/>
                </Route>

                <Route path='about'>
                  <Route index element={<HelpTopicAboutIndex />} />
                  <Route path='first-step' element={<HelpTopicFirstStep />}/>
                  <Route path='2' element={<HelpTopicHowOrganizeEvent />}/>
                  <Route path='3' element={<HelpTopicCreateEvent />}/>
                  <Route path='fonctionnement' element={<HelpTopicFonctionnement />}/>
                  <Route path='4' element={<HelpTopicContactAssistance />}/>
                  <Route path='5' element={<HelpTopicRemarque />}/>
                  <Route path='6' element={<HelpTopicQuoiComment />}/>
                  <Route path='juridiques' element={<HelpTopicJuridiques />}/>
                  <Route path='60' element={<HelpTopicConditionsService />}/>
                  <Route path='62' element={<HelpTopicPolitiqueConfidentialite />}/>
                  <Route path='63' element={<HelpTopicProtectionData />}/>
                </Route>

                <Route path='gestion-compet'>
                  <Route index element={<HelpTopicGestionCompetIndex />} />
                  <Route path='general' element={<HelpTopicGeneral />}/>
                  <Route path='53' element={<HelpTopicDashboard />}/>
                  <Route path='54' element={<HelpTopicCreerAnnonce />}/>
                  <Route path='55' element={<HelpTopicCreerCategorie />}/>
                  <Route path='56' element={<HelpTopicGestionParticipants />}/>
                  <Route path='57' element={<HelpTopicCreerWOD />}/>
                  <Route path='58' element={<HelpTopicCreerAjouterScore />}/>
                  <Route path='59' element={<HelpTopicCreerPlanning />}/>
                </Route>

                <Route path='versements'>
                  <Route index element={<HelpTopicVersementIndex />} />
                  <Route path='fonctionnment-versements' element={<HelpTopicFonctionnementVersements />}/>
                  <Route path='61' element={<HelpTopicQuandRecevoirPaiement />}/>
                </Route>
              </Route>

              {/* catch all others */}
              <Route path='*' element={<ErrorMissing />} />
          </Route>
        </Route>
      </Routes>
    </>
    // </AppDataProvider>
  );
}

export default App;